export default __webpack_public_path__ + "static/media/about-me.c22e4e26.jpg";